<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <h5>Current Time: {{time_updated_every_sec|longTime}}</h5>
      </div>
      <div>
        Remaining real clock time in this session: {{remaining_time_in_session|formatSeconds}} <br />
        Time spend working: {{time_spend_in_session.corrected|formatSeconds}} <br />
        Time spend pausing: {{time_spend_in_session.paused|formatSeconds}} <br />
      </div>
    </el-card>
    <pre v-if="SHOW_DEBUG">
time_spend_in_session: {{time_spend_in_session}}
remaining_time_in_session: {{remaining_time_in_session}}
elapsed_time_in_session: {{elapsed_time_in_session}}
currently_active_session: {{currently_active_session}}
currently_active_session_is_paused: {{currently_active_session_is_paused}}
is_session_overdrawn: {{is_session_overdrawn}}
    </pre>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    sessionId: null,
    selectedGoalId: null,
    isPaused: false
  }),
  watch: {
    /* timer minutes */
    time_updated_every_sec(time) {
      // console.log("tik2", time);
    },
    now_updated_every_min(time) {
      // console.log("tok2", time);
    },
  },
  computed: {
    ...mapGetters("session",[
      "time_updated_every_sec",
      "now_updated_every_min",
      "time_spend_in_session",
      "remaining_time_in_session",
      "elapsed_time_in_session",
      "currently_active_session",
      "currently_active_session_is_paused",
      "is_session_overdrawn"
    ]),
  },
  methods: {
  },
}
</script>
